// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3Ga_a","info":"PatientInfo_info__3LdC2"};